/* eslint react/no-multi-comp: 0, react/prop-types: 0 */

import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Label, Tooltip } from 'reactstrap';
import { connect } from 'react-redux'
import moment from 'moment';

class DocumentAuditModal extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      actions: []
    };
  }

  componentDidMount = () => {
    if (this.props.file.ActionData && this.props.file.ActionData.ActionRef) //Bug 13474: Inscribe - Selecting 'Audit' from the popup for SDN (non transactional) document types crashes screen
    {
      const DocumentRef = this.props.file.DocumentRef;
      const ActionRef = this.props.file.ActionData.ActionRef;

      fetch(`/api/actions/get_actions_for_document?reference=${DocumentRef}&actionRef=${ActionRef}`)
        .then(res => res.json())
        .then(result => {
          this.setState({
            actions: result
          })
        })
    }
  }

  toggleToolTip = (message, id) => {
    if (message.length > 50)
      this.setState({
        [id]: !this.state[id]
      })
  }

  render() {
    const { localisation } = this.props.userReducer;
    const { users, id, makeInactive } = this.props;

    let messages = [];

    if (this.state.actions)
      this.state.actions.forEach((message, i) => {
        let container_status = {}

        if (message.status == 'COMPLETE')
          container_status = <div class="s-fonticon-btn s-icon-status s-icon-status-success"></div>
        else if (message.status == 'ERROR')
          container_status = <div class="s-fonticon-btn s-icon-status s-icon-status-error"></div>
        else
          container_status = <div class="s-fonticon-btn s-icon-status s-icon-status-info"></div>

        messages.push(<div style={{ display: 'inline-flex', padding: '15px', width: '100%' }}>{container_status}
          <Label id={'tooltip' + message._id} style={{ fontSize: '.9rem', width: '70%' }}>{message.message.length > 100 ? message.message.substr(0, 100) + '  ...' : message.message}</Label>
          <Tooltip placement="bottom" isOpen={this.state[message._id]} target={'tooltip' + message._id} toggle={() => this.toggleToolTip(message.message, message._id)}>
            {message.message}
          </Tooltip>
          <Label style={{ fontSize: '.7rem', paddingLeft: '15px', textAlign: 'right' }}>{moment(message.datetime).format('HH:mm:ss DD/MM/YYYY')}</Label></div>);
      })
    return (
      <div>
        <Modal isOpen={this.props.modal} toggle={this.props.toggle} className={this.props.className}>
          <ModalHeader toggle={this.props.toggle}>{"Transaction Audit"}</ModalHeader>
          <ModalBody>
            {messages}
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.props.toggle}>Close</Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export default connect(state => state)(DocumentAuditModal);